import { useState, useEffect } from 'react';

type OutgoingMailConfigType = {
	enabled: boolean;
	canEditConfig: boolean;
};

export type OutgoingMailConfigDataType = {
	outgoingMailConfig: OutgoingMailConfigType | null;
	error: string | null;
	loading: boolean;
};

export const useOutgoingMailConfig = (): OutgoingMailConfigDataType => {
	const [outgoingMailConfig, setOutgoingMailConfig] = useState<OutgoingMailConfigType | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchOutgoingMailConfig = async () => {
			try {
				setLoading(true);
				const response = await fetch('/rest/jira-mail-plugin/1.0/outgoingMail/config');
				if (!response.ok) {
					throw new Error('Failed to fetch outgoingMailConfig');
				}
				const data = await response.json();
				setOutgoingMailConfig(data);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (e: any) {
				setError(e.message);
			} finally {
				setLoading(false);
			}
		};
		fetchOutgoingMailConfig();
	}, []);

	return { outgoingMailConfig, loading, error };
};
